/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Conversation,
  ConversationCreateRequest,
  ConversationsListParams,
  ConversationsMarkReadCreate200,
  ConversationsMessagesListParams,
  Message,
  MessageCreateRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Get all conversations for the user's company (company-to-company and moderator). Optional search on counterpart name (company or moderator) and message content. Sorted by last message date (most recent first). Paginated.
 * @summary List conversations
 */
export const conversationsList = (
    params?: ConversationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Conversation[]>(
      {url: `/api/v1/conversations/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConversationsListQueryKey = (params?: ConversationsListParams,) => {
    return [`/api/v1/conversations/`, ...(params ? [params]: [])] as const;
    }

    
export const getConversationsListQueryOptions = <TData = Awaited<ReturnType<typeof conversationsList>>, TError = unknown>(params?: ConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conversationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConversationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationsList>>> = ({ signal }) => conversationsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 120000, gcTime: 300000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof conversationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ConversationsListQueryResult = NonNullable<Awaited<ReturnType<typeof conversationsList>>>
export type ConversationsListQueryError = unknown

/**
 * @summary List conversations
 */
export const useConversationsList = <TData = Awaited<ReturnType<typeof conversationsList>>, TError = unknown>(
 params?: ConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conversationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConversationsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get a single conversation by ID. Use composite id: c-{id} for company conv, m-{id} for moderator conv.
 * @summary Get conversation detail
 */
export const conversationsDetailRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Conversation>(
      {url: `/api/v1/conversations/${id}/detail/`, method: 'GET', signal
    },
      );
    }
  

export const getConversationsDetailRetrieveQueryKey = (id: string,) => {
    return [`/api/v1/conversations/${id}/detail/`] as const;
    }

    
export const getConversationsDetailRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof conversationsDetailRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conversationsDetailRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConversationsDetailRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationsDetailRetrieve>>> = ({ signal }) => conversationsDetailRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 120000, gcTime: 300000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof conversationsDetailRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ConversationsDetailRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof conversationsDetailRetrieve>>>
export type ConversationsDetailRetrieveQueryError = void

/**
 * @summary Get conversation detail
 */
export const useConversationsDetailRetrieve = <TData = Awaited<ReturnType<typeof conversationsDetailRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conversationsDetailRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConversationsDetailRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Mark messages as read. Use composite id: c-{id} or m-{id}.
 * @summary Mark messages as read
 */
export const conversationsMarkReadCreate = (
    id: string,
 ) => {
      
      
      return customInstance<ConversationsMarkReadCreate200>(
      {url: `/api/v1/conversations/${id}/markRead/`, method: 'POST'
    },
      );
    }
  


export const getConversationsMarkReadCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversationsMarkReadCreate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof conversationsMarkReadCreate>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof conversationsMarkReadCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  conversationsMarkReadCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConversationsMarkReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof conversationsMarkReadCreate>>>
    
    export type ConversationsMarkReadCreateMutationError = void

    /**
 * @summary Mark messages as read
 */
export const useConversationsMarkReadCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversationsMarkReadCreate>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof conversationsMarkReadCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getConversationsMarkReadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get all messages in a conversation. Use composite id: c-{id} or m-{id}. Paginated.
 * @summary List messages
 */
export const conversationsMessagesList = (
    id: string,
    params?: ConversationsMessagesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Message[]>(
      {url: `/api/v1/conversations/${id}/messages/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConversationsMessagesListQueryKey = (id: string,
    params?: ConversationsMessagesListParams,) => {
    return [`/api/v1/conversations/${id}/messages/`, ...(params ? [params]: [])] as const;
    }

    
export const getConversationsMessagesListQueryOptions = <TData = Awaited<ReturnType<typeof conversationsMessagesList>>, TError = void>(id: string,
    params?: ConversationsMessagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conversationsMessagesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConversationsMessagesListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationsMessagesList>>> = ({ signal }) => conversationsMessagesList(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 120000, gcTime: 300000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof conversationsMessagesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ConversationsMessagesListQueryResult = NonNullable<Awaited<ReturnType<typeof conversationsMessagesList>>>
export type ConversationsMessagesListQueryError = void

/**
 * @summary List messages
 */
export const useConversationsMessagesList = <TData = Awaited<ReturnType<typeof conversationsMessagesList>>, TError = void>(
 id: string,
    params?: ConversationsMessagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof conversationsMessagesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConversationsMessagesListQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Send a new message in a conversation. Use composite id: c-{id} or m-{id}.
 * @summary Send message
 */
export const conversationsSendCreate = (
    id: string,
    messageCreateRequest: MessageCreateRequest,
 ) => {
      
      
      return customInstance<Message>(
      {url: `/api/v1/conversations/${id}/send/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageCreateRequest
    },
      );
    }
  


export const getConversationsSendCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversationsSendCreate>>, TError,{id: string;data: MessageCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof conversationsSendCreate>>, TError,{id: string;data: MessageCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof conversationsSendCreate>>, {id: string;data: MessageCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  conversationsSendCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConversationsSendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof conversationsSendCreate>>>
    export type ConversationsSendCreateMutationBody = MessageCreateRequest
    export type ConversationsSendCreateMutationError = void

    /**
 * @summary Send message
 */
export const useConversationsSendCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversationsSendCreate>>, TError,{id: string;data: MessageCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof conversationsSendCreate>>,
        TError,
        {id: string;data: MessageCreateRequest},
        TContext
      > => {

      const mutationOptions = getConversationsSendCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a conversation from a match result. Only matchResultId is required. Your company is auto-detected from the authenticated user. One conversation per match result — if one already exists for this deal, it is returned (200). A new conversation opens only after the matched supplier has accepted the match (403 while pending or declined).
 * @summary Create conversation
 */
export const conversationsCreateCreate = (
    conversationCreateRequest: ConversationCreateRequest,
 ) => {
      
      
      return customInstance<Conversation>(
      {url: `/api/v1/conversations/create/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: conversationCreateRequest
    },
      );
    }
  


export const getConversationsCreateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversationsCreateCreate>>, TError,{data: ConversationCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof conversationsCreateCreate>>, TError,{data: ConversationCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof conversationsCreateCreate>>, {data: ConversationCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  conversationsCreateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConversationsCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof conversationsCreateCreate>>>
    export type ConversationsCreateCreateMutationBody = ConversationCreateRequest
    export type ConversationsCreateCreateMutationError = void

    /**
 * @summary Create conversation
 */
export const useConversationsCreateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversationsCreateCreate>>, TError,{data: ConversationCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof conversationsCreateCreate>>,
        TError,
        {data: ConversationCreateRequest},
        TContext
      > => {

      const mutationOptions = getConversationsCreateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    